import { buttonClass } from "@/components/common/controls";
import { FileUploadIcon } from "@/components/icons";
import { SectionCard } from "@/components/posting/parts";
import { actionProps } from "@/lib/controlAnalytics";
import { UPLOAD_ACCEPT } from "@/lib/resumeImport/files";
import { pasteBoxClass } from "./styles";

/** An old Word file is offered too, so it gets its own line rather than a greyed name. */
const ACCEPT = `${UPLOAD_ACCEPT},.doc`;

/** The fade over the last line of a filled box, so more text reads as more below. */
const FADE =
    "after:pointer-events-none after:absolute after:inset-x-0.5 after:bottom-0.5 after:h-[30px] after:rounded-b-[14px] after:bg-gradient-to-b after:from-transparent after:to-card-raised";

/**
 * The resume: an ordinary box, filled by typing or from a file read in
 * this browser. With a result up, the box takes the room on a desktop and
 * gives it up on a phone, where the count stays in the strip.
 */
export default function ResumeBox({
    resume,
    onChange,
    onPick,
    caption,
    settled,
}: {
    resume: string;
    onChange: (text: string) => void;
    onPick: (file: File) => void;
    caption: string;
    settled: boolean;
}) {
    const height = settled ? "h-[460px] max-[760px]:h-[150px]" : "h-[330px] max-[760px]:h-[220px]";
    return (
        <SectionCard className="gap-3.5" title="Your resume" caption={caption}>
            <span className={`relative block ${resume === "" ? "" : FADE}`}>
                <textarea
                    {...actionProps("resume_paste_edited", {
                        source: "ResumeCheck",
                        field: "resume",
                    })}
                    aria-label="Your resume"
                    placeholder="Paste the text of your resume, from LinkedIn or a doc"
                    value={resume}
                    onChange={(event) => onChange(event.target.value)}
                    className={pasteBoxClass(resume !== "", height)}
                />
            </span>
            <label
                className={`${buttonClass("secondary", "md")} w-fit cursor-pointer focus-within:outline-2 focus-within:outline-offset-2 focus-within:outline-green`}
            >
                <input
                    {...actionProps(
                        "resume_file_selected",
                        { source: "ResumeCheck" },
                        "resume_file_picker_opened",
                    )}
                    type="file"
                    accept={ACCEPT}
                    onChange={(event) => {
                        const file = event.target.files?.[0];
                        if (file) onPick(file);
                        event.target.value = "";
                    }}
                    className="sr-only"
                />
                <FileUploadIcon className="size-3.5" />
                Choose a PDF or Word file
            </label>
        </SectionCard>
    );
}
